/*
 *
 * Package: `@dbh/smart-section-theme`.
 *
 */const THEME_KEY_SMART_SECTION="smartSection";const modifySmartSectionTheme=a=>{let{colors:{greyUltralight:b},spacing:{sp6:c,sp7:d}}=a;return {[THEME_KEY_SMART_SECTION]:{borderBottom:"1px solid "+b,padding:"0 "+c+" "+d,desktop:{padding:"0 0 "+d}}}};

export { THEME_KEY_SMART_SECTION, modifySmartSectionTheme as default };
